// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"318": "__federation_expose_InsuranceStats","560": "__federation_expose_Ledger","841": "__federation_expose_PatientStats","889": "__federation_expose_AiUsageStats",}[chunkId] || chunkId) + "." + {"286": "b5211779","318": "8cdc6835","34": "a0611e04","396": "a46d8f3d","434": "086c2232","560": "1c394865","685": "1337e9f8","75": "7f41536f","823": "371352e0","841": "a76126e4","889": "443031d2",}[chunkId] + ".js"
}